import {
  Box,
  CircularProgress,
  FormControl,
  FormControlOwnProps,
  Select,
  TextField,
} from '@mui/material';
import { styled } from '@mui/material/styles';

interface InputProps {
  open?: boolean;
  error?: boolean;
}

export const Search = styled(TextField)(() => ({
  '.MuiInputBase-input': {
    padding: '14.5px 15px 14.5px 5px',
    color: 'rgba(34, 40, 34, 1)', // Colore esplicito per il testo
  },

  fieldset: {
    top: 0,
  },
}));

export const SelectInput = styled(Select)(() => ({
  fieldset: {
    top: 0,
  },
}));

export const AutocompleteInput = styled(TextField)<InputProps>(({ open }) => ({
  '.MuiOutlinedInput-root': {
    padding: '0',
    fontWeight: 600,

    ' .MuiAutocomplete-input': {
      padding: '5.5px 10px',
    },
  },

  '.MuiInputBase-input': {
    '&::placeholder': {
      color: open ? 'rgba(159, 159, 159, 1)' : 'rgba(34, 40, 34, 1)',
      fontWeight: open ? 400 : 600,
      opacity: 1,
    },

    '&:placeholder-shown': {
      textOverflow: 'ellipsis',
    },
  },

  fieldset: {
    top: 0,
  },
}));

export const Item = styled('li')(() => ({
  '.MuiCheckbox-root': {
    marginRight: '8px',
  },

  svg: {
    marginRight: '5px',
  },
}));

export const AutocompleteItem = styled(Item)(() => ({
  '&.MuiAutocomplete-option[aria-selected="true"]': {
    background: 'rgba(30, 237, 159, 1) !important',
  },
}));

export const Loader = styled(CircularProgress)(() => ({
  position: 'absolute',
  left: '50%',
  transform: 'translate(-50%, 0)',
}));

export const MultiValueFormControl = styled(FormControl)<FormControlOwnProps>(
  ({ error }) => ({
    padding: '4.5px 10px',
    border: `1px solid ${error ? '#F44336' : 'rgba(221, 221, 234, 1)'}`,
    borderRadius: '6px',
    width: 'unset',

    '&:hover, &:focus': {
      borderColor: error ? '#F44336' : '#1EED9F',
    },

    '&:focus, &:focus-within': {
      boxShadow: `0 0 0 1px ${error ? '#F44336' : '#1EED9F'}`,
    },

    '.MuiInputBase-input': {
      padding: '0',
      fontWeight: 600,

      '&::placeholder': {
        fontWeight: 400,
      },
    },

    '.MuiOutlinedInput-notchedOutline': {
      border: 'transparent',
    },

    '.MuiFormControl-root': {
      width: 'unset',
      flexGrow: 1,
    },

    fieldset: {
      top: 0,
    },
  }),
);

export const ChipsContainer = styled(Box)(() => ({
  display: 'flex',
  gap: '10px',
  flexWrap: 'wrap',
  alignItems: 'center',
}));
